/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_TitleInputs */

const en_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery`)
};

const pl_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeneracja`)
};

/**
* | output |
* | --- |
* | "Recovery" |
*
* @param {Recovery_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const recovery_title = /** @type {((inputs?: Recovery_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_recovery_title(inputs)
	return en_recovery_title(inputs)
});